// removed by extract-text-webpack-plugin
module.exports = {"container":"_1-Ja4BZfXP53ivdQw6Fjrm","callInfo":"_2NCV7fp2lOuPpiDwEV2rGy","noTasks":"_2t3ry48SYu8LT8tE3zyfEi"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2de97386","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/Home/Tasks.less
// module id = D8kS
// module chunks = 1